module.exports = __webpack_public_path__ + "images/icons/psp-car-storage-guide/10x20-car.svg";